import React from 'react';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { Button, Row, Col, Modal, ModalBody, Input } from 'reactstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from '../../assets/styles/style.sass';
import s2 from './dialog.sass';
import s3 from './sms.sass';
import {
  setIsShowSMSPhoneDialog,
  setIsShowSMSVerfiyDialog,
  setIsSendingSMS,
  setIsShowSMSVerfiyLoadingDialog,
  setIsShowSMSVerfiySuccessDialog,
} from '../../actions/dialog';
import { localStorageGet } from '../../service/localStorage';
import { sendSMS, verificationSMS, getUser } from '../../api/user';

const verifyCodeInputLenght = [0, 1, 2, 3];
class smsVerifyDialog extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    setIsShowSMSVerfiyDialog: PropTypes.func.isRequired,
    setIsShowSMSPhoneDialog: PropTypes.func.isRequired,
    setIsShowSMSVerfiyLoadingDialog: PropTypes.func.isRequired,
    setIsShowSMSVerfiySuccessDialog: PropTypes.func.isRequired,
    onSetIsMobilePhone: PropTypes.func.isRequired,
    modal: PropTypes.bool.isRequired,
    second: PropTypes.number.isRequired,
    setIsSendingSMS: PropTypes.func.isRequired,
    isSendingSMS: PropTypes.bool.isRequired,
    isMobilePhone: PropTypes.bool.isRequired,
    modelDataText: PropTypes.shape().isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      errorVerificationCode: false,
      exceedRetryLimit: false,
      verifyCode: [],
      phone: localStorageGet('auth.phone', false),
    };
    this.onYes = this.onYes.bind(this);
    this.onClickRendSMS = this.onClickRendSMS.bind(this);
  }

  componentDidMount() {
    if (
      ['2', '3'].includes(this.state.phone.replace('825', '')[0]) &&
      this.props.currentLocale.split('-')[1].toLowerCase() === 'hk'
    ) {
      this.props.onSetIsMobilePhone(false);
    }
  }

  onYes() {
    verificationSMS(
      this.state.verifyCode.toString().replace(/,/g, ''),
      this.props.currentLocale,
    ).then(result => {
      switch (result.status) {
        case 503:
          this.setState({ exceedRetryLimit: true });
          break;
        case 500:
        case 401:
        case 404:
        case 403:
          this.setState({ errorVerificationCode: true });
          break;
        default:
          this.props.setIsShowSMSVerfiyDialog();
          this.props.setIsShowSMSVerfiyLoadingDialog();
          setTimeout(() => {
            this.props.setIsShowSMSVerfiyLoadingDialog();
            this.props.setIsShowSMSVerfiySuccessDialog();
            getUser(null, this.props.currentLocale);
            setTimeout(() => {
              this.props.setIsShowSMSVerfiySuccessDialog();
            }, 500);
          }, 500);
          break;
      }
    });
  }

  onClickRendSMS() {
    sendSMS(this.props.currentLocale, this.props.setIsSendingSMS);
  }

  render() {
    return (
      <div id="smsVerifyDialog">
        <Modal
          className={`${s2.dialog} ${s2.infoPopup}`}
          isOpen={this.props.modal}
          // isOpen
          toggle={() => {
            this.props.setIsShowSMSVerfiyDialog();
          }}
        >
          <Button
            outline
            color="link"
            className={`${s.infoCloseRightButton} ${s2.dialogOverlayClose} ${
              s2.smallcloseRightButton
            }`}
            onClick={() => {
              this.props.setIsShowSMSVerfiyDialog();
            }}
          />
          <ModalBody
            className={`${s2.smsContainer} ${s3.smsContainer} ${s3.smsError}`}
          >
            <div>
              {this.state.errorVerificationCode ? (
                <p
                  className={`${s3.smsErrorTop} ${s2.dialogErrorMessage}`}
                  style={{ marginTop: '0px' }}
                >
                  {this.props.modelDataText.sms_incorrect_verification_code}
                </p>
              ) : (
                ''
              )}
              {this.state.exceedRetryLimit ? (
                <p className={`${s3.smsErrorTop} ${s2.dialogErrorMessage}`}>
                  {this.props.modelDataText.sms_exceed_the_limit}
                </p>
              ) : (
                ''
              )}
            </div>
            <div className={s3.stepTwo}>
              <h2>{this.props.modelDataText.sms_complete_your_profile}</h2>
              <div className={s3.stepTwoProgress}>
                <p className={s3.done}>
                  {this.props.modelDataText.sms_register}
                </p>
                <p className={s3.doing}>
                  {this.props.modelDataText.sms_verification}
                </p>
              </div>
              {this.props.isMobilePhone ? (
                <p>{this.props.modelDataText.sms_sent_to_your_phone}</p>
              ) : (
                <p>{this.props.modelDataText.sms_call_cs_to_verify}</p>
              )}
              <p className={`${s.globalFontLight} ${s.globalTextBlue}`}>
                {localStorageGet('auth.phone', false)}
              </p>
              <p className={s.globalFontLight}>
                {this.props.modelDataText.sms_enter_your_verify_code}
              </p>
              <div className={s3.smsConfirmField}>
                {verifyCodeInputLenght.map(i => (
                  <Input
                    key={i}
                    maxLength="1"
                    className={`${s3.input} ${s3.quartar}`}
                    onKeyUp={e => {
                      if (e.target.value !== '') {
                        this.state.verifyCode[i] = e.target.value;
                        e.target.nextSibling.focus();
                      }
                    }}
                  />
                ))}
                <br />
                <br />
                <Row>
                  <Col>
                    <Button
                      className={`${s.button} ${s.primary} ${s.globalTextBlue}`}
                      style={{ width: '100%' }}
                      onClick={() => {
                        this.onYes();
                      }}
                    >
                      {this.props.modelDataText.sms_submit}
                    </Button>
                  </Col>
                  <Col>
                    {!this.props.isSendingSMS ? (
                      <Button
                        className={`${s.button} ${s.secondary} ${s.outlined} `}
                        style={{ width: '100%' }}
                        onClick={() => {
                          this.onClickRendSMS();
                        }}
                      >
                        {this.props.modelDataText.sms_resend}
                      </Button>
                    ) : (
                      <Button
                        className={`${s2.buttonTwoLine} ${s2.disabled} ${
                          s2.buttonDisableBG
                        }`}
                        style={{ width: '100%' }}
                        onClick={() => {}}
                      >
                        <span className={s2.disableText}>
                          {this.props.modelDataText.sms_sending}
                        </span>
                        <br />
                        <span className={s2.disableText}>
                          ({this.props.modelDataText.sms_sec_remaining_prefix}
                          {this.props.second}
                          {this.props.modelDataText.sms_sec_remaining_suffix})
                        </span>
                      </Button>
                    )}
                  </Col>
                </Row>
              </div>
              <p>
                {this.props.modelDataText.sms_entered_a_wrong_no}
                &nbsp;
                <span
                  className={s.globalTextBlue}
                  role="button"
                  style={{ cursor: 'pointer' }}
                  tabIndex={0}
                  onClick={() => {
                    this.props.setIsShowSMSVerfiyDialog();
                    this.props.setIsShowSMSPhoneDialog();
                  }}
                  onKeyPress={() => {}}
                >
                  {this.props.modelDataText.sms_use_a_different_no}
                </span>
              </p>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  modal: state.dialog.isShowSMSVerifyDialog,
  isSendingSMS: state.dialog.isSendingSMS,
});
const mapDispatch = {
  setIsShowSMSVerfiyDialog,
  setIsShowSMSPhoneDialog,
  setIsSendingSMS,
  setIsShowSMSVerfiyLoadingDialog,
  setIsShowSMSVerfiySuccessDialog,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2, s3)(smsVerifyDialog),
);



// WEBPACK FOOTER //
// ./src/components/Dialog/smsVerifyDialog.js